<div class="page-container">
    <app-navigasjon></app-navigasjon>
    <section class="main-content">
        <router-outlet></router-outlet>
    </section>
</div>